import { Button } from "@/components/ui/button";
import { Check, X } from "lucide-react";

interface CommentComparisonViewProps {
  originalComment: string;
  improvedComment: string;
  onAccept: () => void;
  onReject: () => void;
  indicatorColor: string;
}

export function CommentComparisonView({
  originalComment,
  improvedComment,
  onAccept,
  onReject,
  indicatorColor,
}: CommentComparisonViewProps) {
  return (
    <div className="space-y-2.5 p-2.5 bg-neutral-100/60 dark:bg-[#0e0e0e] rounded border border-neutral-200/60 dark:border-neutral-700/30">
      <div className="text-[10px] font-medium uppercase tracking-wider text-neutral-400 dark:text-neutral-500">
        AI Suggestion
      </div>
      
      <div className="space-y-2">
        <div className="space-y-1">
          <div className="text-[9px] font-medium text-neutral-400 dark:text-neutral-500 uppercase tracking-widest">
            Original
          </div>
          <div className="text-[13px] text-neutral-600 dark:text-neutral-400 bg-white/80 dark:bg-[#141414] p-2 rounded border border-neutral-200/60 dark:border-neutral-700/40 leading-relaxed">
            {originalComment}
          </div>
        </div>
        
        <div className="space-y-1">
          <div className="text-[9px] font-medium uppercase tracking-widest" style={{ color: indicatorColor }}>
            Suggested
          </div>
          <div 
            className="text-[13px] text-neutral-800 dark:text-neutral-200 p-2 rounded border leading-relaxed"
            style={{ 
              backgroundColor: `${indicatorColor}06`,
              borderColor: `${indicatorColor}25`
            }}
          >
            {improvedComment}
          </div>
        </div>
      </div>
      
      <div className="flex items-center gap-1.5 pt-0.5">
        <Button
          variant="outline"
          size="sm"
          onClick={onReject}
          className="flex-1 h-7 text-[10px] tracking-wide border-neutral-200/60 dark:border-neutral-700/40 text-neutral-500 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-[#1a1a1a]"
          data-testid="button-reject-improvement"
        >
          <X className="h-2.5 w-2.5 mr-1" />
          Keep Original
        </Button>
        <Button
          size="sm"
          onClick={onAccept}
          className="flex-1 h-7 text-[10px] tracking-wide text-white border-0"
          style={{ backgroundColor: indicatorColor }}
          data-testid="button-accept-improvement"
        >
          <Check className="h-2.5 w-2.5 mr-1" />
          Use Suggestion
        </Button>
      </div>
    </div>
  );
}
